import { IncomingMessage } from 'http';

import { asNetworkAware } from '../../utils/network-error';
import { fechFromBPartsApi } from '../utils';

export const fetchShippingLocations = (
  {
    locale,
  }: {
    locale: string;
  },
  req?: IncomingMessage
): Promise<ShippingLocations> =>
  fechFromBPartsApi(`/${locale}/shop/shipping_locations`, {
    credentials: 'include',
    headers: req ? new Headers(req.headers as HeadersInit) : undefined,
  }).then((value) => value.json());

// TODO: add correct TS
export const fetchUserShippingLocation = ({
  locale,
}: {
  locale: string;
}): Promise<{ id: number }> => {
  const endpoint = `/${locale}/shop/shipping_locations/selected`;

  // só o `fetch` vai dentro do `asNetworkAware` — o `.json()` fica de fora para
  // que um payload inválido continue a ser reportado como erro nosso
  return asNetworkAware(
    `GET ${endpoint}`,
    fechFromBPartsApi<Response>(endpoint, {
      credentials: 'include',
    })
  ).then((value) => value.json());
};
